import React, { useCallback, useState } from 'react'
import { Box, Container, IconButton, Typography } from '../imports/muiImport'
import { NavLink, useNavigate } from 'react-router-dom';

import Login from './authPages/Login';
import OTPComponent from './otp/OTPComponent';
import { verifyForgotUserOTP, verifyUserOTPForLogin } from '../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { actionNotifier } from '../components/tostify';
import { userTokenSave } from '../apiCalls/functions';
import { useAuth } from '../hooks/contexts/AuthContext';
import Timer from '../pages/LOGIN_SIGNUP/OTP/Timer';
import { validateOtp } from '../apiCalls/urls/urlFunction';
import { Helmet } from 'react-helmet-async';
import ForgetPassword from './authPages/ForgetPassword';
import MobileNewPassword from '../mobile/mobileComponents/mobileUserAccountLogin/MobileNewPassword';

const PasswordResetPage = () => {
  const [passwordResetFormStep, setPasswordResetFormStep] = useState({
    isShowUserPhoneForm: true,
    isShowOTPForm: false,
    isShowNewPasswordForm: false
  });
  const [passwordResetToken, setPasswordResetToken] = useState('');

  const [showOTPForm, setOTPForm] = useState(false);

  const [isResendAvailable, setIsResendAvailable] = useState(false);
  const [otpFormLoading, setOtpFormLoading] = useState(false);
  const [isResetOtp, setIsResetOtp] = useState(false);
  const [isUserAuthentic, setIsUserAuthentic] = useState({});
  const [otpFormTimer, setOtpFormTimer] = useState(60);
  const [noOfUserOTPSend, setNoOfUserOTPSend] = useState(0);


  const { authUser, setAuthUser, isLoggedIn, setIsLoggedIn } = useAuth();
  const navigate = useNavigate();

  const handleUserForm = (key) => {
    setPasswordResetFormStep((prevState) => {
      switch (key) {
        case "USERPHONEFORMFILLSUCCESSFUL":
          return {
            ...prevState,
            isShowUserPhoneForm: false,
            isShowOTPForm: true,
            isShowNewPasswordForm: false
          };
        case "USERPASSWORDRESETFORMFILLSUCCESSFUL":
          return {
            ...prevState,
            isShowUserPhoneForm: false,
            isShowOTPForm: false,
            isShowNewPasswordForm: true
          };
        default:
          return {
            isShowUserPhoneForm: true,
            isShowOTPForm: false,
            isShowNewPasswordForm: false
          };
      }
    });
  };


  const handleOtpVerify = async (user_phone, user_otp) => {
    setOtpFormLoading(true);
    const passwordResetResponse = await verifyForgotUserOTP(user_phone, user_otp);

    // something went wrong - error
    if (!passwordResetResponse?.status) {

      setOtpFormLoading(false);
      return false;
    }

    const forgetUserToken = passwordResetResponse?.data?.data?.otpToken;
    if (forgetUserToken) {
      setPasswordResetToken(forgetUserToken);
      handleUserForm('USERPASSWORDRESETFORMFILLSUCCESSFUL');

      setTimeout(() => {
        setOtpFormLoading(false);
      }, 3000);
      return true;
    }
  }

  const handleOtpResend = async (mobile) => {
    if (isResendAvailable) {
      const response = await validateOtp(mobile);
      if (response?.status) {
        setNoOfUserOTPSend((prevState) => prevState + 1);
        setOtpFormTimer(() => 60);

        actionNotifier.info("OTP has been resent", { position: "top-left", autoClose: 1000 });
      }
    } else {
      actionNotifier.warning(`Please wait for the timer to resend OTP`, { position: "top-left", autoClose: 1000 });
    }
  }

  const userLoginSuccessfully = (token) => {
    let loginToken = userTokenSave(token);

    if (loginToken) {
      // Set true User Login Status it will reflect every where
      setIsLoggedIn(true);

      // Notification remove 
      actionNotifier.clearAll();
      navigate("/", { replace: true });
    }
  }

  const timerEnd = () => {
    if (noOfUserOTPSend <= 2) {
      setIsResendAvailable(() => true);
      setOtpFormTimer(() => null);
      setOtpFormLoading(false);
    } else {
      setOtpFormLoading(false);
      setIsResetOtp(true);
      setIsResendAvailable(() => false);
      window.location.reload();
    }
  }



  return (
    <Box component="div">
      <Helmet>
        <title>Signup -99gift.in</title>
        <meta property="og:title" content="Signup -99gift.in" />
      </Helmet>

      {passwordResetFormStep?.isShowUserPhoneForm &&
        (
          <ForgetPassword
            setIsUserAuthentic={setIsUserAuthentic}
            handleUserForm={handleUserForm}
          />
        )
      }


      {passwordResetFormStep?.isShowOTPForm &&
        (
          <>
            <OTPComponent
              phone={isUserAuthentic?.mobile}
              purpose="Password Reset OTP"
              loading={otpFormLoading}
              isResendAvailable={isResendAvailable}
              onVerifyOtp={handleOtpVerify}
              onResendOtp={handleOtpResend}
              isResetOtp={isResetOtp}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",

              }}
            >
              <Timer
                initialTime={otpFormTimer}
                timeEnd={timerEnd}
                timerStyle={{}}
              />
            </Box>
          </>
        )
      }


      {passwordResetFormStep?.isShowNewPasswordForm &&
        (
          <>
            <MobileNewPassword forgotToken={passwordResetToken} />
          </>
        )
      }
    </Box>
  )
}

export default PasswordResetPage